'use strict';

module.exports = function () {
    var sizes = ['xs', 'sm', 'md', 'lg', 'xl'];

    sizes.forEach(function (size) {
        var selector = '.collapsible-' + size + ' .title';
        $('body').on('click', selector, function (e) {
            e.preventDefault();
            $(this).parents('.collapsible-' + size).toggleClass('active');

            if ($(this).parents('.collapsible-' + size).hasClass('active')) {
                $(this).attr('aria-expanded', true);
            } else {
                $(this).attr('aria-expanded', false);
            }
        });
    });

    /**
     * This function checks the state of a checkbox with the class `.points-toggle-control-js`
     * and updates the state of collapsible elements and the `.cart-zip-section` based on that state.
     * 
     * @returns {void} This function does not return any value.
     */
    (function() {
        if ($('.points-toggle-control-js').length > 0 && $('.points-toggle-control-js').data('loyalty-is-points-toggled')) {
            $('.cart-zip-section').addClass('active');
            $('.cart-zip-section .title').attr("aria-expanded", "true");
            $('.cart-zip-section .title').attr("disabled", "true");
            $('.points-toggle-control-js').prop('checked', true);
        } else {
            $('.cart-zip-section').removeClass('active');
            $('.cart-zip-section .title').attr("aria-expanded", "false");
            $('.cart-zip-section .title').removeAttr("disabled");
            $('.points-toggle-control-js').prop('checked', false);
        }
    })();

    $('.points-toggle-control-js').click(function () {
        if ($(this).prop('checked')) {
            $('.cart-zip-section').addClass('active');
            $('.cart-zip-section .title').attr("aria-expanded", "true");
            $('.cart-zip-section .title').attr("disabled", "true");
        } else {
            $('.cart-zip-section').removeClass('active');
            $('.cart-zip-section .title').attr("aria-expanded", "false");
            $('.cart-zip-section .title').removeAttr("disabled");
        }
    });
};
